import React, { Component } from "react";
import CalendarView from "../../views/Calendar/CalendarView";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as calendarActions from "../../redux/actions/calendarActions";
import CalendarModals from "../../views/Calendar/CalendarModals";
import { isIframeAdmin } from "../../utils/iframe";

const modalNames = {
  createEvent: "createEvent",
  editEvent: "editEvent",
  createCalendar: "createCalendar",
  importCalendar: "importCalendar",
  exportCalendar: "exportCalendar",
  calendarSettings: "calendarSettings"
};

class LearningCenterCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      event: null,
      openModals: {
        [modalNames.calendarSettings]: false,
        [modalNames.createCalendar]: false,
        [modalNames.createEvent]: false,
        [modalNames.editEvent]: false,
        [modalNames.exportCalendar]: false,
        [modalNames.importCalendar]: false,
        calendarLists: null,
        allCalendars: []
      }
    };
  }

  componentDidMount() {
    this.props.actions.fetchCalendarInfo();
  }

  componentDidUpdate() {
    const { calendarLists } = this.props;
    if (calendarLists !== this.state.calendarLists) {
      this.setState({
        openModals: { ...this.state.openModals, createEvent: false }
      });

      this.setState({ calendarLists }, () => {
        this.setState({
          allCalendars: calendarLists.training.calendars.concat(
            calendarLists.other.calendars
          )
        });
      });
    }
  }

  handleOpenModalChange = modalName => open => {
    const currentModalsState = this.state.openModals;
    if (modalName === "exportCalendar") {
      this.props.actions.fetchCalendarFeedLink();
    }
    this.setState({
      openModals: {
        ...currentModalsState,
        [modalName]: open
      }
    });
  };

  onEditEventModalOpenChange = ({ event }) => {
    //Learners can only open events in 'My Events' calendar
    const { user } = this.props;
    const isAdmin =
      user.isAdmin ||
      isIframeAdmin(user, ["Policy Admin", "System Admin", "Validate"]);
    if (!isAdmin && event && event.extendedProps.calendarName !== "My Events") {
      return;
    }

    if (
      (event && event.extendedProps.calendarType === "other") ||
      this.state.openModals[modalNames.editEvent]
    ) {
      this.setState({ event }, () => {
        this.handleOpenModalChange(modalNames.editEvent)(
          !this.state.openModals[modalNames.editEvent]
        );
      });
    }
  };

  handleCreateNewEvent = newEventData => {
    if (this.validateEvent(newEventData)) {
      this.props.actions.createNewEvent(newEventData);
    }
  };

  handleDeleteEvent = event => {
    this.props.actions.deleteEvent(event);
    this.handleOpenModalChange(modalNames.editEvent)(
      !this.state.openModals[modalNames.editEvent]
    );
  };

  handleUpdateEvent = eventData => {
    if (this.validateEvent(eventData)) {
      this.props.actions.updateEvent(this.state.event.id, eventData);
    }
    this.handleOpenModalChange(modalNames.editEvent)(
      !this.state.openModals[modalNames.editEvent]
    );
  };

  validateEvent(event) {
    return true;
  }

  handleCreateNewCalendar = newCalendarData => {
    this.props.actions.createNewCalendar(newCalendarData);
  };

  handleImportCalendar = importedCalendarData => {
    this.props.actions.importNewCalendar(importedCalendarData);
  };

  handleUpdateCalendarSettings = newCalendarSettingsData => {
    this.props.actions.updateCalendarSettings(newCalendarSettingsData);
  };

  render() {
    const { updateSelectedCalendars, calendarLists, calendarFeed } = this.props;
    const { openModals, allCalendars, event } = this.state;

    const handleOpenModalsChanges = {
      onImportModalOpenChange: this.handleOpenModalChange(
        modalNames.importCalendar
      ),
      onSettingsModalOpenChange: this.handleOpenModalChange(
        modalNames.calendarSettings
      ),
      onExportModalOpenChange: this.handleOpenModalChange(
        modalNames.exportCalendar
      ),
      onCreateEventModalOpenChange: this.handleOpenModalChange(
        modalNames.createEvent
      ),
      onCreateCalendarModalOpenChange: this.handleOpenModalChange(
        modalNames.createCalendar
      )
    };

    return (
      <React.Fragment>
        <CalendarView
          userPermissions={this.props.user.permissions}
          calendarLists={calendarLists}
          allCalendars={allCalendars}
          onSelectedCalendarsChange={updateSelectedCalendars}
          onEditEventModalOpenChange={this.onEditEventModalOpenChange}
          {...handleOpenModalsChanges}
        />
        <CalendarModals
          user={this.props.user}
          onUpdateCalendarSettings={this.handleUpdateCalendarSettings}
          onImportNewCalendar={this.handleImportCalendar}
          onCreateNewEvent={this.handleCreateNewEvent}
          onDeleteEvent={this.handleDeleteEvent}
          onUpdateEvent={this.handleUpdateEvent}
          onCreateNewCalendar={this.handleCreateNewCalendar}
          importModalOpen={openModals.importCalendar}
          exportModalOpen={openModals.exportCalendar}
          calendarFeedLink={calendarFeed}
          settingsModalOpen={openModals.calendarSettings}
          createEventModalOpen={openModals.createEvent}
          editEventModalOpen={openModals.editEvent}
          createEventModalErrors={this.props.error}
          event={event}
          createCalendarModalOpen={openModals.createCalendar}
          trainingCalendars={calendarLists.training}
          allCalendars={allCalendars}
          otherCalendars={calendarLists.other}
          onEditEventModalOpenChange={this.onEditEventModalOpenChange}
          {...handleOpenModalsChanges}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.userState.user,
  calendarLists: state.calendarState.calendarLists,
  calendarFeed: state.calendarState.feedLink,
  error: state.calendarState.error
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(calendarActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningCenterCalendar);
